import axios from "axios";
import data from "../../../assets/apiRoutes.json";
class ReceiptService {
  deleteReceiptDetailItem(request) {
    return axios.post(
      `${window._env_.REACT_APP_APIS}/${data.Receipt.DeleteReceiptDetailItem}`,
      request,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: request.access_token,
        },
      }
    );
  }
}

export default ReceiptService;
